import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from "react-router-dom";

import "./App.css";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import LoginSection from "./components/LoginSection";
import Dashboard from "./components/Dashboard/Dashboard";

import Email from "./pages/Authentican/OtpFOrgot/Email";
import OtpVerify from "./pages/Authentican/OtpFOrgot/OtpVerify";
import ConfirmPassword from "./pages/Authentican/OtpFOrgot/Password";

import FaqJobHost from "./pages/CMsManagement/FaqJobHost";
import FaqJobSeeker from "./pages/CMsManagement/FaqJobSeeker";

import TermsConditionsData from "./pages/CMsManagement/TermsConditionsData";
import PrivacyPolicyData from "./pages/CMsManagement/PrivacyPolicyData";

import DeleteAccount from "./pages/CMsManagement/DeleteAccount";

import ProfileManagement from "./pages/Authentican/Profile/Profile";
import VerifyOtp from "./pages/Authentican/ForgotPassword/VerifyOtp";
import ChangedPassword from "./pages/Authentican/ForgotPassword/ChangedPassowrd";

import UserManagement from "./pages/UserManagement/UserManagement";
import UserDetails from "./pages/UserManagement/UserDetails";
import RegistrationRequest from "./pages/UserManagement/RegistrationRequest";
import RegistrationDetails from "./pages/UserManagement/RegistrationDetails";
import CertificateRequest from "./pages/UserManagement/CertificateRequest";


import SkillsManagement from "./pages/SkillsManagement/SkillsManagement";

import BlockManagement from "./pages/BlockManagement/BlockManagement";
import BlockManagementDetails from "./pages/BlockManagement/BlockManagementDetails";
import AddUpdateBlock from "./pages/BlockManagement/AddUpdateBlock";

import CommissionSettings from "./pages/Commission Settings/CommissionSettings";

import GigsManagement from "./pages/GigsManagement/GigsManagement";
import GigOverview from "./pages/GigsManagement/GigOverview";

import ReportedGig from "./pages/ReportedGigManagement/ReportedGig";
import ReportUserList from "./pages/ReportedGigManagement/ReportUserList";

import Leaderboard from "./pages/Leaderbord/Leaderboard";

import SubAdminManagement from "./pages/SubAdmin/subAdminManagement"
import AddUpdateSubAdmin from "./pages/SubAdmin/AddUpdateSubAdmin";
import SubAdminHistory from "./pages/SubAdmin/subAdminHistory";


import CMSManagements from "./pages/CMsManagement/PrivacyPolicy";
import AboutUs from "./pages/CMsManagement/AboutUs";
import TermsCondition from "./pages/CMsManagement/TermsCondition";
import ContactUs from "./pages/CMsManagement/ContactUs";
import FAQs from "./pages/CMsManagement/FAQs";
import CreateFaq from "./pages/CMsManagement/CreateFaq";

import PaymentManagement from "./pages/PaymentManagement/PaymentManagement";

import TicketManagement from "./pages/TicketManagement/TicketManagement";
import TicketHistory from "./pages/TicketManagement/TicketHistory";

import NotificationManagement from "./pages/NotificationManagement/NotificationManagement";
import CreateNotification from "./pages/NotificationManagement/CreateNotification";

import FeedbackManagement from "./pages/FeedbackManagement/FeedbackManagement";











const PublicRoute = ({ defaultState }) => (
  <Routes>
    <Route path="/" element={<LoginSection {...defaultState} />} />
    <Route path="/eMail" element={<Email />} />
    <Route path="/otpVerify" element={<OtpVerify />} />
    <Route path="/confirmPassword" element={<ConfirmPassword />} />
    <Route path="/verify-otp" element={<VerifyOtp />} />

    <Route path="/faqJobHost" element={<FaqJobHost />} />
    <Route path="/faqJobSeeker" element={<FaqJobSeeker />} />

    <Route path="/terms-and-conditions" element={<TermsConditionsData />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyData />} />

    <Route path="/delete_account" element={<DeleteAccount />} />
  </Routes>
);

// const permissionRoutes = []

const PrivateRoute = ({ userData, defaultState }) => (
  <Routes>
    {/* {userData.modules.filter(item => item.Dashboard?  : "")} */}

    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/dashboard" element={<><Navbar /><Sidebar /><Dashboard /></>} />

    <Route path="/userManagement" element={<><Navbar /><Sidebar /><UserManagement /></>} />
    <Route path="/userDetails/:id" element={<><Navbar /><Sidebar /><UserDetails /></>} />
    <Route path="/registrationRequest" element={<><Navbar /><Sidebar /><RegistrationRequest /></>} />
    <Route path="/registrationDetails/:id" element={<><Navbar /><Sidebar /><RegistrationDetails /></>} />
    <Route path="/certificateRequest" element={<><Navbar /><Sidebar /><CertificateRequest /></>} />

    <Route path="/skillsManagement" element={<><Navbar /><Sidebar /><SkillsManagement /></>} />

    <Route path="/blockManagement" element={<><Navbar /><Sidebar /><BlockManagement /></>} />
    <Route path="/blockManagementDetails/:id" element={<><Navbar /><Sidebar /><BlockManagementDetails /></>} />

    <Route path="/addUpdateBlockManagement" element={<><Navbar /><Sidebar /><AddUpdateBlock /></>} />
    <Route path="/commissionSettings" element={<><Navbar /><Sidebar /><CommissionSettings /></>} />

    <Route path="/gigsManagement" element={<><Navbar /><Sidebar /><GigsManagement /></>} />
    <Route path="/gigOverview/:id" element={<><Navbar /><Sidebar /><GigOverview /></>} />

    <Route path="/reportedGigManagement" element={<><Navbar /><Sidebar /><ReportedGig /></>} />
    <Route path="/reportUserList/:id" element={<><Navbar /><Sidebar /><ReportUserList /></>} />

    <Route path="/leaderboardManagement" element={<><Navbar /><Sidebar /><Leaderboard /></>} />

    <Route path="/subAdminManagement" element={<><Navbar /><Sidebar /><SubAdminManagement /></>} />
    <Route path="/subAdminDetail" element={<><Navbar /><Sidebar /><AddUpdateSubAdmin /></>} />
    <Route path="/subAdminDetailHistory/:id" element={<><Navbar /><Sidebar /><SubAdminHistory /></>} />


    <Route path="/cmsManagement" element={<><Navbar /><Sidebar /><CMSManagements /></>} />
    <Route path="/aboutUs" element={<><Navbar /><Sidebar /><AboutUs /></>} />
    <Route path="/contactUs" element={<><Navbar /><Sidebar /><ContactUs /></>} />
    <Route path="/terms&Conditions" element={<><Navbar /><Sidebar /><TermsCondition /></>} />
    <Route path="/fAQs" element={<><Navbar /><Sidebar /><FAQs /></>} />
    <Route path="/addUpdateFAQs" element={<><Navbar /><Sidebar /><CreateFaq /></>} />

    <Route path="/paymentManagement" element={<><Navbar /><Sidebar /><PaymentManagement /></>} />

    <Route path="/ticketManagement" element={<><Navbar /><Sidebar /><TicketManagement /></>} />
    <Route path="/ticketManagementHistory/:id" element={<><Navbar /><Sidebar /><TicketHistory /></>} />

    <Route path="/notificationManagement" element={<><Navbar /><Sidebar /><NotificationManagement /></>} />
    <Route path="/createNotification" element={<><Navbar /><Sidebar /><CreateNotification /></>} />

    <Route path="/feedbackManagement" element={<><Navbar /><Sidebar /><FeedbackManagement /></>} />



    <Route path="/profile" element={<><Navbar /><Sidebar /><ProfileManagement /></>} />
    <Route path="/changedPassword" element={<><Navbar /><Sidebar /><ChangedPassword /></>} />
  </Routes>
);

function App(props) {
  const { userData } = props;
  const navigate = useNavigate();


  useEffect(() => {
    if (userData === null) {

      const publicAllowed = ["/", "/eMail", "/otpVerify", "/confirmPassword", "/verify-otp", "/faqJobHost", "/faqJobSeeker", "/terms-and-conditions", "/privacy-policy", "/delete_account",];
      if (!publicAllowed.includes(window.location.pathname)) {
        navigate("/");
      }
    }
  }, [userData, navigate]);

  useEffect(() => {
    window.addEventListener("storage", (e) => {
      if (e.key === "token" && !e.newValue) {
        window.location.replace("/");
      }
    });
  }, []);


  return (
    <div>
      {userData ? <PrivateRoute userData={userData} defaultState={props.defaultState} /> : <PublicRoute defaultState={props.defaultState} />}
      <ToastContainer />
    </div>
  );
}

const mapStateToProps = (state) => ({
  defaultState: state.defaultState,
  userData: state.userData,
});

export default connect(mapStateToProps)(App);
